import { createSlice } from '@reduxjs/toolkit';

const signalQualification = {
  code: 200,
  data: {
    meanRSSI: -62,
    weakPercent: 3,
    totalClient: 350,
    threshold: -70,
    apCount: 1,
    series: [
      {
        rssi: -30,
        count: 35,
      },
      {
        rssi: -40,
        count: 55,
      },
      {
        rssi: -50,
        count: 110,
      },
      {
        rssi: -60,
        count: 60,
      },
      {
        rssi: -70,
        count: 45,
      },
      {
        rssi: -80,
        count: 30,
      },
      {
        rssi: -90,
        count: 15,
      },
    ],
  },
};

const devices = {
  code: 200,
  data: {
    threshold: -70,
    devices: [
      {
        count: 42,
        deviceId: '00:11:22:33:00:01',
        deviceName: 'AP-Parking-Gate-North',
      },
      {
        count: 28,
        deviceId: '00:11:22:33:00:02',
        deviceName: 'AP-Roof-Garden-Area',
      },
      {
        count: 19,
        deviceId: '00:11:22:33:00:03',
        deviceName: 'AP-Warehouse-Corner-Z',
      },
      {
        count: 12,
        deviceId: '00:11:22:33:00:04',
        deviceName: 'AP-Meeting-Room-04',
      },
      {
        count: 7,
        deviceId: '00:11:22:33:00:05',
        deviceName: 'AP-Lobby-Entrance',
      },
    ],
  },
};

const initialState = {
  signalQualification,
  devices,
};

export const ainsightWirelessCoverageSlice = createSlice({
  name: 'aInsightWirelessCoverage',
  initialState,
  reducers: {
    updateThreshold: (state, action) => {
      // console.log('Payload: ', action.payload);
      const newThreshold = action.payload.data.threshold;
      state.devices.data.threshold = newThreshold;
      state.signalQualification.data.threshold = newThreshold;
      // console.log('reducers updated state:', current(state));
    },
  },
});

export const { updateThreshold } = ainsightWirelessCoverageSlice.actions;

export default ainsightWirelessCoverageSlice.reducer;
